import { createSvgIcon } from '@mui/material/utils';

const CardVisaIcon = createSvgIcon(
  <>
    <path fill="#2100c4" d="M22.5 17.5a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2Zm0 0" />
    <path
      fill="#fff"
      d="M7.594 9.5 6.28 13.414s-.336-1.656-.367-1.863c-.75-1.703-1.851-1.61-1.851-1.61L5.362 15h1.582L9.13 9.5Zm1.25 5.5h1.437l.867-5.5H9.695Zm10.16-5.5h-1.512L15.137 15h1.43l.292-.785h1.797l.153.785h1.308Zm-1.746 3.664.781-2.078.406 2.078Zm-4.074-2.062c0-.301.25-.528.964-.528.465 0 .997.336.997.336l.23-1.152s-.68-.258-1.344-.258c-1.511 0-2.289.723-2.289 1.637 0 1.652 1.988 1.425 1.988 2.273 0 .145-.113.485-.94.485-.833 0-1.38-.305-1.38-.305l-.25 1.105s.531.305 1.559.305c1.031 0 2.457-.77 2.457-1.875 0-1.332-1.992-1.43-1.992-2.023Zm0 0"
    />
    <path fill="#f5bc00" d="m6.105 12.473-.484-2.375s-.215-.512-.785-.512H2.617s2.828.836 3.488 2.887Zm0 0" />
  </>,
  'CardVisaIcon',
);

export default CardVisaIcon;
